import React from "react";
const HireBtn = () => {
  return (
    <button className="fixed -right-6 top-[50%] rotate-90 z-30 rounded-full bg-scColor">
      <a
        href="https://www.upwork.com/freelancers/~01a8c06c7cdb1685cf"
        target={"_blank"}
        rel="noreferrer"
        className="btn-primary shadow shadow-borderColor hover:shadow-none "
      >
        <span className="rotate-180">Hire Me</span>
      </a>
    </button>
  );
};

export default HireBtn;
